import { TranslateService } from '@ngx-translate/core';
import { Injectable, inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private translate = inject(TranslateService);


    private languages = {
        "ENGLISH": "en",
        "GERMAN": "de",
        "SPANISH": "es",
        "INDONESIAN": "id",
        "JAPANESE":"ja",
        "DUTCH":"nl",
        "POLISH":"pl",
        "PORTUGUESE":"pt",
        "RUSSIAN":"ru",
        "ITALIAN":"it",
        "SWEDISH":"sv",
        "FINNISH":"fi",
        "NORWEGIAN":"no",
        "TURKEY":"tr",
        "CHINESE":"zh"

    };

    private currentLanguageIsoCode: string;


    constructor() {
        this.translate.addLangs(Object.values(this.languages));
        this.translate.setDefaultLang(this.languages.ENGLISH);
        const browserLanguage = this.translate.getBrowserLang() ?? 'en';
        this.updateCurrentLanguageByIsoCode(browserLanguage);
    }


    public getCurrentIsoCode() {
        return this.currentLanguageIsoCode;
    }

    public findIsoCode(string: string): string {
        return this.languages[string.replace('"', '')];
    }


    public updateCurrentLanguageByIsoCode(isocode: string): void {
        this.translate.use(isocode);
        this.currentLanguageIsoCode = isocode;
    }
}
